/**
 * Extrai a mensagem de erro de um objeto de erro.
 * 
 * @param {Object} error - O objeto de erro.
 * @param {string} defaultMessage - A mensagem padrão caso nenhuma seja encontrada.
 * @returns {string} - A mensagem de erro extraída.
 */
export const extractErrorMessage = (error, defaultMessage = 'Ocorreu um erro inesperado.') => {
  return error?.response?.data?.message || error?.response?.data?.error || defaultMessage;
};